export default "__VITE_ASSET__DzUom72r__"